import './BarV2.css';

import React from 'react';

import { NavLink } from 'react-router-dom';

import { AGENCY_TOOLS, REDESIGN_WORKSPACES_PAGE, ENABLE_API_CONNECTIONS_PAGE, REDESIGN_AMAZON_ATTRIBUTION_PAGE, useFeatureFlag } from 'lib/configcat';

import { Accounts } from './Items/Accounts';
import AccountSettings from './Items/AccountSettings';
import { AdsProvider } from './Items/AdsProvider';
import { Amazon } from './Items/Amazon';
import AudienceBuilder from './Items/AudienceBuilder';
import { Billing } from './Items/Billing';
import { Help } from './Items/Help';

const BarV2 = ({
  account,
  limitations,
}: {
  account: accountT,
  user: userT,
  sub: subscriptionT,
  limitations: any,
}): React$Element<'nav'> => {
  const [isAgencyToolsEnabled] = useFeatureFlag(AGENCY_TOOLS);
  const [isRedesignWorkspacesEnabled] = useFeatureFlag(REDESIGN_WORKSPACES_PAGE);
  const [isApiConnectionsEnabled] = useFeatureFlag(ENABLE_API_CONNECTIONS_PAGE);
  const [isRedesignAmazonAttributionPageEnabled] = useFeatureFlag(REDESIGN_AMAZON_ATTRIBUTION_PAGE);

  return (
    <nav className="bar-v2" style={{ 'grid-area': 'bar' }}>
      <ul>
        {isAgencyToolsEnabled &&
          (isRedesignWorkspacesEnabled ? (
            <a href={`/v2/workspaces?wsId=${account.id}&orgId=${account.organizationId}`}>
              <li className="bar-menu-item">
                <Accounts />
              </li>
            </a>
          ) : (
            <NavLink to={`/${account.id}/accounts`} activeClassName="current">
              <li className="bar-menu-item">
                <Accounts />
              </li>
            </NavLink>
          ))}
        {isRedesignAmazonAttributionPageEnabled ? (
          <a href={`/v2/products?wsId=${account.id}&orgId=${account.organizationId}`}>
              <li className="bar-menu-item">
                <AdsProvider />
              </li>
            </a>
        ) : (
          <NavLink to={`/${account.id}/adsprovider`} activeClassName="current">
            <li className="bar-menu-item">
              <AdsProvider />
            </li>
          </NavLink>
        )}
        <NavLink to={`/${account.id}/ab`} activeClassName="current">
          <li className="bar-menu-item">
            <AudienceBuilder />
          </li>
        </NavLink>

        {!isApiConnectionsEnabled && (
          <NavLink to={`/${account.id}/amazon`} activeClassName="current">
            <li className="bar-menu-item">
              <Amazon />
            </li>
          </NavLink>
        )}

        <NavLink to={`/${account.id}/b`} activeClassName="current">
          <li className="bar-menu-item">
            <Billing />
          </li>
        </NavLink>

        <a href={`/v2/settings/organization?wsId=${account.id}&orgId=${account.organizationId}`}>
          <li className="bar-menu-item">
            <AccountSettings />
          </li>
        </a>

        <a href="https://www.carbon6.io/pixelme-help" target="_blank" rel="noopener noreferrer">
          <li className="bar-menu-item">
            <Help />
          </li>
        </a>
      </ul>
    </nav>
  );
};

export default BarV2;
